export const i18n = localizations => key => localizations[key] || key

export const getLocaleFromPath = () => {
  if (typeof location === 'undefined') {
    return ''
  }

  const pathParts = location.pathname.split('/')
  const locale = pathParts[1]

  return locale === '' ? 'en' : locale
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js